/* eslint-disable react-hooks/exhaustive-deps */
import { Button, DatePicker, Form, Input, message, Modal, Select } from 'antd'
import moment from 'moment';
import React,{ useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';


const mapStateToProps = ({dispatch, profile, user}) => ({
  dispatch,
  profileLoading: profile.loading,
  bankList: profile.bankList,
  bankAccount: profile.bankAccount,
  fileUploadUrl: user.fileUploadUrl,
  userLoading: user.loading,
  paymentModal: user.paymentModal,
})
function PaymentComponent({
  dispatch,
  bankList,
  bankAccount,
  fileUploadUrl,
  userLoading,
  paymentModal,
}) {
  const fileUploadData = new FormData()
  const {hash} = window.location

  const [inputDetails, setInputDetails] = useState({
    full_name: "",
    email: "",
    phone_no: "",
    oracle_no: "",
    date: "",
    amount: "",
    image: "",
    account_name: bankAccount.account_name || "",
    account_no: bankAccount.account_number || "",
    bank_name: "",
    type: "",
    description: "",
  })

  const setPaymentModal = payload => dispatch({type: "user/HANDLE_PAYMENT_MODAL", payload})
  // const { account_no: acctNo } = inputDetails
  useEffect(() => {
    setInputDetails({
      ...inputDetails,
      account_name: bankAccount.account_name,
      account_no: bankAccount.account_number,
      bank_name: inputDetails.bank_name
    })
  }, [bankAccount, inputDetails.bank_name])

  useEffect(() => {dispatch({type: "profile/GET_PROFILE_BANKS"})}, [dispatch])
  useEffect(() => {setInputDetails({...inputDetails, image: fileUploadUrl})}, [fileUploadUrl])
  const handleFileUpload = (file) => {
    if(file[0]){
      fileUploadData.append("image_file", file[0])
      dispatch({type: 'user/GET_FILE_UPLOAD_URL', payload: fileUploadData})
    }else{
      message.error({
        content: "no file selected",
        duration: 4
      })
    }
  }
  return (
    <div className="w-100">
      <Link to={hash.slice(1)} onClick={()=>{setPaymentModal(true)}}>
        <h5 className="fs-6 text-light">Notify Payment</h5>
      </Link>

      <Modal
        title="Notify Payment"
        visible={paymentModal}
        maskClosable={false}
        style={{top: 20}}
        onCancel={()=>setPaymentModal(false)}
        footer={false}
        width="80%"
      >
        <div className='w-full'>
          <div className='container'>
            <Form className='row' layout='vertical' onFinish={()=>dispatch({type: "user/NOTIFY_PAYMENT", payload: inputDetails})}>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Full Name"
                  name="full_name"
                  rules={[{required: true}]}
                >
                  <Input placeholder='full name' size='large' value={inputDetails.full_name} onChange={({target:{value}})=>setInputDetails({...inputDetails, full_name: value})} />
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[{required: true}]}
                >
                  <Input type='email' placeholder='email' size='large' value={inputDetails.email} onChange={({target:{value}})=>setInputDetails({...inputDetails, email: value})} />
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Mobile Number"
                  name="phone_no"
                  rules={[{required: true}]}
                >
                  <Input type='number' minLength={10} placeholder='phone number' size='large' value={inputDetails.phone_no} onChange={({target:{value}})=>setInputDetails({...inputDetails, phone_no: value})} />
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Payment Type"
                  name="type"
                  rules={[{required: true}]}
                >
                  <Select placeholder='forms of payment..' size='large' value={inputDetails.type} onChange={(value)=>setInputDetails({...inputDetails, type: value})}>
                    {/* <Select.Option key="cheq" value="cheque">Cheque</Select.Option> */}
                    <Select.Option key="trans" value="transfer">Transfer</Select.Option>
                    <Select.Option key="trans" value="cash">Cash Deposit</Select.Option>
                  </Select>
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Member ID"
                  name="oracle_no"
                  rules={[{required: true}]}
                  // rules={[{required: !!inputDetails.type?.includes("deduction")}]}
                >
                  <Input placeholder='membership id / number' size='large' value={inputDetails.oracle_no} onChange={({target:{value}})=>setInputDetails({...inputDetails, oracle_no: value})} />
                </Form.Item>
              </div>
              {/* <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Oracle Number"
                  name="oracle_no"
                  // rules={[{required: true}]}
                  rules={[{required: !!inputDetails.type?.includes("deduction")}]}
                >
                  <Input placeholder='oracle number' size='large' value={inputDetails.oracle_no} onChange={({target:{value}})=>setInputDetails({...inputDetails, oracle_no: value})} />
                </Form.Item>
              </div> */}
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Transaction Date"
                  name="date"
                  rules={[{required: true}]}
                >
                  <DatePicker className='w-100' placeholder='date of the transaction' picker="date" size='large' value={moment(inputDetails.date || "")} onChange={(string, value)=>setInputDetails({...inputDetails, date: value})} />
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Amount"
                  name="amount"
                  rules={[{required: true}]}
                >
                  <Input type='number' placeholder='amount paid' size='large' value={inputDetails.amount} onChange={({target:{value}})=>setInputDetails({...inputDetails, amount: value})} />
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Eveidence of Payment"
                  name="image"
                  rules={[{required: true}]}
                >
                  <Input type='file' placeholder='image' accept=".jpg, .jpeg, .png, .pdf" onChange={({target: {files}})=> handleFileUpload(files)} />
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Account Number"
                  name="account_no"
                  rules={[{required: true}]}
                >
                  <Input size='large' maxLength={10} placeholder='account number you pay into' value={inputDetails.account_no} onChange={({target: {value}})=> setInputDetails({...inputDetails, account_no: value})} />
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item 
                  label="Recipient Bank"
                  name="bank_code"
                >
                  <select
                    placeholder="select bank you to pay into"
                    className='form-control'
                    disabled={!inputDetails.account_no}
                    value={inputDetails.bank_name}
                    onChange={(name)=> {
                      const code = bankList?.find(e=>e.name===name.target.value)?.code
                      setInputDetails({...inputDetails, bank_name: name.target.value});
                      dispatch({type: 'profile/GET_BANKS_ACCOUNT', payload: {account_no: inputDetails.account_no, code}});
                    }}
                  >
                    {/* > */}
                    <option value="" disabled>Select bank you pay into</option>
                    {bankList.map((val)=>(
                      <option key={val.code} value={val.name}>
                        {val.name}
                      </option>
                    ))}
                  </select>                
                </Form.Item> 
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Account Name"
                  name="account_name"
                >
                  <Input size='large' placeholder={inputDetails.account_name || 'account name'} disabled value={inputDetails.account_name} onChange={({target:{value}})=> setInputDetails({...inputDetails, account_name: value})} />
                </Form.Item>
              </div>
              <div className='col-sm-6 col-md-4'>
                <Form.Item
                  label="Purpose of Payment"
                  name="description"
                  required
                >
                  <Input required size='large' placeholder="purpose of payment" value={inputDetails.description} onChange={({target:{value}})=>setInputDetails({...inputDetails, description: value})} />
                </Form.Item>
              </div>
              <div className='pt-4 w-50 mx-auto'>
                <Button loading={userLoading} type='primary' size='large' block htmlType='submit'>
                  Proceed
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </Modal>

    </div>
  )
}

export default connect(mapStateToProps)(PaymentComponent)
